module.exports = __webpack_public_path__ + "img/1.0edcf1d9.jpg";